import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import IndexDashboard from './IndexDashboard';
import './App.css';

const App = () => {
  const [indexes, setIndexes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchIndexes = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/indexes'); // Fetch all years
      if (!response.ok) {
        throw new Error('Failed to fetch indexes');
      }
      const data = await response.json();
      console.log("Fetched indexes:", data);
      setIndexes(data.indexes || []);
      setError(null);
    } catch (err) {
      console.error("Error fetching indexes:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIndexes();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<IndexDashboard indexes={indexes} loading={loading} error={error} />} />
      <Route path="/ifp" element={<IndexDashboard indexes={indexes} loading={loading} error={error} />} />
    </Routes>
  );
};

export default App;
